import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useStores } from 'hooks';
import { useQuery } from '@apollo/react-hooks';
import idDecoder from 'lib/utils/idDecoder';
import getViewer from '../graphql/getViewer.graphql';
import getPermissionsQuery from '../graphql/getPermissions.graphql';


export const useViewerPermissions = ({ client, onGetViewerError, onGetPermissionError }) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { authStore } = useStores();

  const { data: viewerData = {}, loading: viewerLoading } = useQuery(getViewer, {
    client,
    fetchPolicy: 'network-only',
    onError: onGetViewerError,
    skip: !authStore.currentIdentity,
  });

  const shopId = idDecoder(_.get(viewerData, 'viewer.shop._id', ''));

  const { data: permissionData = {}, loading: permissionsLoading } = useQuery(
    getPermissionsQuery,
    {
      client,
      variables: { shopId },
      fetchPolicy: 'network-only',
      onError: onGetPermissionError,
      skip: !shopId,
    },
  );
  useEffect(() => {
    authStore.setViewer(viewerData.viewer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewerData]);

  useEffect(() => {
    authStore.setPermission(_.get(permissionData, 'getPermissions.permissionKey', []));
    setIsCompleted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionData]);

  // eslint-disable-next-line
  useEffect(() => {
    _.isEmpty(authStore.currentIdentity) && setIsCompleted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.currentIdentity]);

  return [isCompleted, viewerLoading, permissionsLoading];
};
